import { FilterDescriptor } from '@progress/kendo-data-query'
import { useAppSelector } from 'store'

import { SelectFilter } from '../SelectFilter'

interface NotificationAudienceTypeFilterProps {
  filter: FilterDescriptor
  onFilterChange: (event: { nextFilter: FilterDescriptor }) => void
}

export const NotificationAudienceTypeFilter: React.FC<NotificationAudienceTypeFilterProps> = (
  props
) => {
  const { filter, onFilterChange } = props
  const notificationAudienceTypes = useAppSelector(
    (state) => state.clientArea.notificationAudienceTypes
  )

  const data = notificationAudienceTypes.map((x) => ({ id: x.id, label: x.name, value: x.id }))

  return (
    <SelectFilter
      placeholder='Audience Type'
      filter={filter}
      onFilterChange={onFilterChange}
      data={data}
      style={{ width: 240 }}
    />
  )
}
